<script>
import { mapActions } from "vuex";

import LoadingSpinner from "../../components/LoadingSpinner.vue";
import ReportSections from "./reportSections.vue";
import SectionTexts from "./sectionTexts.vue";

export default {
    components: {
        ReportSections,
        SectionTexts,
        LoadingSpinner
    },

    data() {
        return {
            loading: false,
            activeTab: 'reportSections',

            surveys: {
                su1: [],
                su2: [],
                selectedSu2Survey: null,
            },

            language: "en",
            selectedReportLanguages: null,
        }
    },

    async mounted() {
        await this.setLoading(true);
        this.language = localStorage.getItem('lang');
        await this._getCompanyReportPublishingStatus();
        await this.getSurveys();
        await this.setLoading(false);
    },

    methods: {
        ...mapActions("surveys", [
            "getSU1Surveys",
            "getSU2Surveys",
        ]),

        ...mapActions('company', [
            'getCompanyReportPublishingStatus',
        ]),

        // api requests //

        async getSurveys() {
            await this.getSU1Surveys({ company_id: this.$user.company_id, created_by: this.$user.user_id, is_deleted: false })
                .then(res => {
                    this.surveys.su1 = res.data;
                })
                .catch(({ response }) => {
                    console.error(response.data.messageName);
                })

            await this.getSU2Surveys({ company_id: this.$user.company_id, is_deleted: false, is_approved: true })
                .then(res => {
                    this.surveys.su2 = res.data;
                    if (res.data.length > 0) this.surveys.selectedSu2Survey = res.data[0];
                })
                .catch(({ response }) => {
                    console.error(response.data.messageName);
                })
        },

        async _getCompanyReportPublishingStatus() {
            await this.getCompanyReportPublishingStatus()
                .then(res => {
                    this.selectedReportLanguages = res.data.report_languages_selected;
                })
                .catch(error => {
                    console.error(error);
                })
        },

        changeTab(tab) {
            this.activeTab = tab;
        },

        async setLoading(bool) {
            this.loading = bool;
        },
    }


}
</script>

<template>
    <div>
        <!-- using v-show instead of v-if allows me to load the data in the background xd -->
        <div v-show="loading" class="flex-all-centered-row" style="padding-top: 1em;">
            <loading-spinner style="font-size: 2.5em;" />
        </div>

        <div v-show="!loading" class="generate-sections-container">
            <div class="tabs-bar">
                <div class="tab" tabindex="0" :class="{ 'active-tab': activeTab === 'reportSections' }"
                    @click="changeTab('reportSections')" @keydown.enter="changeTab('reportSections')">
                    {{ $t('generateSections.tabs.reportSect') }}
                </div>
                <div class="tab" tabindex="0" :class="{ 'active-tab': activeTab === 'sectionTexts' }"
                    @click="changeTab('sectionTexts')" @keydown.enter="changeTab('sectionTexts')">
                    {{ $t('generateSections.tabs.sectTest') }}
                </div>
            </div>

            <div class="surveys-btn">
                <div class="surveys-title">
                    {{ $t('sideBar.education.surveys.surveys') }}
                </div>
                <select class="surveys-select" v-model="surveys.selectedSu2Survey">
                    <option v-for="survey in surveys" :key="survey.su2_survey_id" :value="survey">
                        {{ survey.su2_survey_name }}
                    </option>
                </select>
            </div>

            <div class="flex-all-centered-row" v-if="!loading">
                <report-sections v-if="activeTab === 'reportSections'"
                    :surveys="surveys"
                    :su2SurveyId="surveys.selectedSu2Survey.su2_survey_id" 
                    :initialLanguage="language"
                    :selectedReportLanguages="selectedReportLanguages" 
                />
                
                <section-texts v-else-if="activeTab === 'sectionTexts'"
                    :initialLanguage="language" 
                    :selectedReportLanguages="selectedReportLanguages"
                />
            </div>

        </div>
    </div>

</template>

<style lang="scss" scoped>
.generate-sections-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.tabs-bar {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 1em;
    outline: thin solid var(--sustainfinity-navy);
    border-radius: 1em;
    overflow: hidden;

    >.tab {
        flex: 1;
        text-align: center;
        background-color: white;
        color: var(--sustainfinity-navy);
        font-weight: bold;
        padding: .25em;

        transition: background-color 150ms;
        cursor: pointer;

        &:hover {
            background-color: lightgray;
        }

        &:focus {
            border: 0;
            outline: 0;
        }
    }

    >.active-tab {
        background-color: var(--sustainfinity-navy) !important;
        color: white !important;
        pointer-events: none !important;
    }
}

.surveys-btn {
    padding: .5em 0;

    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.surveys-title {
    font-size: 1.5em;
    font-weight: bold;
    color: var(--sustainfinity-navy);
}

.surveys-select {
    background: transparent !important;
    border-radius: .75em !important;
    padding: .33em;
    border: .2em solid #212b35 !important;
    outline: none !important;
    cursor: pointer !important;
    width: fit-content !important;
}
</style>